export const getFormFields = () => [
  {
    name: 'number',
    componentName: 'input',
    params: {
      i18nLabel: 'waybills.lot.number',
    },
  },
];
